import SEOHead from '../../components/feature/SEOHead';
import ComunidadeNavbar from './components/ComunidadeNavbar';
import ComunidadeHero from './components/ComunidadeHero';
import ConviteSection from './components/ConviteSection';
import RankingComunidade from './components/RankingComunidade';
import BeneficiosComunidade from './components/BeneficiosComunidade';
import MuralComunidade from './components/MuralComunidade';
import NewsletterComunidade from './components/NewsletterComunidade';
import CTAComunidade from './components/CTAComunidade';
import Footer from '../home/components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const comunidadeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Comunidade | Carta do Eu Futuro',
    url: `${SITE_URL}/comunidade`,
    inLanguage: 'pt-BR',
    description: 'Faça parte da comunidade de transformação pessoal do Carta do Eu Futuro. Conecte-se com pessoas que praticam PNL, gratidão e desenvolvimento pessoal.',
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Início', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: 'Comunidade', item: `${SITE_URL}/comunidade` },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Comunidade Carta do Eu Futuro',
    url: `${SITE_URL}/comunidade`,
    description: 'Comunidade de transformação pessoal com foco em PNL, gratidão e desenvolvimento pessoal.',
    memberOf: {
      '@type': 'Organization',
      name: 'Carta do Eu Futuro',
      url: SITE_URL,
    },
  },
];

const Comunidade = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="Comunidade de Transformação Pessoal | PNL e Gratidão — Carta do Eu Futuro"
        description="Faça parte da comunidade de transformação pessoal do Carta do Eu Futuro. Conecte-se com pessoas que praticam PNL, gratidão e desenvolvimento pessoal."
        keywords="comunidade desenvolvimento pessoal, PNL comunidade, gratidão, transformação pessoal"
        canonical="/comunidade"
        ogImage="https://public.readdy.ai/ai/img_res/0e0eb309ce5d62a6546a5c90cff312a8.jpg"
        ogType="website"
        schema={comunidadeSchema}
      />
      <ComunidadeNavbar />
      <ComunidadeHero />
      <ConviteSection />
      <RankingComunidade />
      <BeneficiosComunidade />
      <MuralComunidade />
      <NewsletterComunidade />
      <CTAComunidade />
      <Footer />
    </div>
  );
};

export default Comunidade;
